module.exports = __webpack_public_path__ + "static/media/threeHearts.c86ae408.png";